module.exports = __webpack_public_path__ + "img/rubbish.94a0ec88.svg";